import { ExerciseService } from "@/common/api.service"
import { FETCH_EXERCISES, FETCH_INDIVIDUAL_EXERCISE, FETCH_ALL_EXERCISES, FETCH_ALL_AVAILABLE_EXERCISES, DOWNLOAD_EXERCISE_TEMPLATE,FETCH_USER_UPLOADED_EXERCISE_ANSWERS, EXERCISE_RESET_STATE} from "./actions.type"
import { SET_EXERCISES, SET_INDIVIDUAL_EXERCISE, SET_OPEN_EXERCISES, SET_AVAILABLE_EXERCISES, SET_ERROR_EXERCISE,SET_UPLOAD_EXERCISE_DATA, STATE_RESET } from "./mutations.type"

const initialState = () => {
    return {
        exercises: [],
        individualexercise: [],
        uploadedexercises: [],
        availableexercises: [],
        exerciseanswers: [],
        exerciseerrors: null,
    }
}

let state = initialState()

const getters = {
    exercises(state) {
        return state.exercises
    },
    uploadedexercises(state) {
        return state.uploadedexercises
    },
    availableexercises(state) {
        return state.availableexercises
    },
    individualexercise(state) {
        return state.individualexercise
    }
}

const actions = {
    async [FETCH_EXERCISES](context, slug) {
        const { data } = await ExerciseService.get(slug)
        context.commit(SET_EXERCISES, data.data)
        return data;
    },
    async [FETCH_INDIVIDUAL_EXERCISE](context, slug) {
        const { data } = await ExerciseService.get(slug)
        context.commit(SET_INDIVIDUAL_EXERCISE, data.data)
        return data;
    }, 
    async [FETCH_ALL_EXERCISES](context, slug) {
        const { data } = await ExerciseService.getopenexercises(slug)
        context.commit(SET_OPEN_EXERCISES, data.data)
        return data;
    }, 
    async [FETCH_ALL_AVAILABLE_EXERCISES](context, slug) {
        const { data } = await ExerciseService.getavailableexercises(slug)
        context.commit(SET_AVAILABLE_EXERCISES, data.data)
        return data;
    }, 
    async [FETCH_USER_UPLOADED_EXERCISE_ANSWERS](context, payload) {
    return await ExerciseService.getuserexercise(payload)
        .then(data => {
        return data
        })
        .catch(error => {
        context.commit(SET_ERROR_EXERCISE, (error.response.data.hasOwnProperty('errors') ? error.response.data.errors : error.response.data.message));
        });
    },
    async [DOWNLOAD_EXERCISE_TEMPLATE](context, payload) {
    return await ExerciseService.downloadFile(payload)
        .then(data => {
        return data
        })
        .catch(error => {
        context.commit(SET_ERROR_EXERCISE, (error.response.data.hasOwnProperty('errors') ? error.response.data.errors : error.response.data.message));
        });
    },
    [EXERCISE_RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = {
    [SET_ERROR_EXERCISE](state, error) {
        state.exerciseerrors = error
    },      
    [SET_EXERCISES](state, data) {
        state.exercises = data
    },
    [SET_OPEN_EXERCISES](state, data) {
        state.uploadedexercises = data
    },
    [SET_AVAILABLE_EXERCISES](state, data) {
        state.availableexercises = data
    },
    [SET_INDIVIDUAL_EXERCISE](state, individualexercise) {
        state.individualexercise = individualexercise
    }, 
    [SET_UPLOAD_EXERCISE_DATA](state, exercise) {
        state.exerciseanswers = exercise
    }, 
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    } 
};

export default {
    state,
    getters,
    actions,
    mutations
};